import MuiCircularProgress from '@mui/material/CircularProgress'

export type CircularProgressSize = 'small' | 'normal' | 'large'

export type CircularProgressProps = {
  size: CircularProgressSize
}

const sizeToPoint = (size: CircularProgressSize): number => {
  switch (size) {
    case 'small':
      return 20
    case 'normal':
      return 40
    case 'large':
      return 120
    default:
      return 40
  }
}

export default function CircularProgress({ size }: CircularProgressProps) {
  return <MuiCircularProgress size={sizeToPoint(size)} />
}
